/**
 * List of child routes (like pop-over routes, ...)
 */
export default {
  MEDIA: {
    id: 'MEDIA',
    fr: ':mediaUid',
    en: ':mediaUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/PopOver/MediaPopOver'),
  },
  PRESS_RELEASE: {
    id: 'PRESS_RELEASE',
    fr: ':pressReleaseUid',
    en: ':pressReleaseUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/PopOver/MediaPopOver'),
  },
  RSE_POPIN: {
    id: 'RSE_POPIN',
    fr: ':popinUid',
    en: ':popinUid',
    fileLoader: /* istanbul ignore next */ () => import('../../pages/RSEPopin'),
  },
};
